// extracted by mini-css-extract-plugin
export var Page = "Page-module--Page--sleDC";
export var aniSpin = "Page-module--ani-spin--SS8EV";
export var border = "Page-module--border--aU-0g";